var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCustomMoveArrow = function SvgCustomMoveArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 21.9-4.945-4.956 1.408-1.409L12 19.07l3.535-3.535 1.415 1.414L12 21.9ZM8.463 8.465 7.05 7.05 12 2.1l4.944 4.955-1.408 1.408L12 4.929 8.464 8.464l-.001.001Z",
    fill: "currentColor"
  })));
};

export default SvgCustomMoveArrow;